import { Injectable, ComponentRef } from '@angular/core';
import { Overlay, OverlayRef, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { PdfPreviewComponent } from '@app/shared/components/pdf-preview/pdf-preview.component';
import { Size } from './utils/a4-ratio-helper';
import { LoaderService, WindowService } from './utils';

@Injectable({ providedIn: 'root' })
export class PdfPreviewService {
  private overlayRef: OverlayRef | null = null;
  private componentRef: ComponentRef<PdfPreviewComponent> | null = null;

  constructor(
    private readonly overlay: Overlay,
    private readonly window: WindowService,
    private readonly loaderService: LoaderService,
  ) {}

  getPdfContainerMaxWidth(): number {
    return this.window.nativeWindow.innerWidth - 16 - 32; // 16px for the vertical scrollbar (shown when pdf is zoomed in); 32px for spacing left and right (16px each).
  }

  getPdfContainerMaxHeight(): number {
    return this.window.nativeWindow.innerHeight - 16 - 32; // 16px for the horizontal scrollbar (shown when pdf is zoomed in); 32px for spacing top and bottom (16px each).
  }

  open(src: string, size: Size, showAllPages: boolean = false) {
    this.showLoader(true);

    const config = new OverlayConfig({
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-dark-backdrop',
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
    });

    this.overlayRef = this.overlay.create(config);

    const portal = new ComponentPortal(PdfPreviewComponent);
    this.componentRef = this.overlayRef.attach(portal);

    this.componentRef.instance.src = src;
    this.componentRef.instance.size = size;
    this.componentRef.instance.showAllPages = showAllPages;

    this.overlayRef.backdropClick().subscribe(() => this.close());
  }

  close() {
    this.showLoader(false);

    this.overlayRef?.dispose();
    this.overlayRef = null;
    this.componentRef = null;
  }

  showLoader(showLoader: boolean): void {
    if (showLoader) {
      this.loaderService.startLoader(false);
    } else {
      this.loaderService.stopLoader();
    }
  }
}
